import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import Image from '../../Image/Image';
const DoubleArrowIcon =
  'https://assets.askhippo.co.za/Icons/common/DoubleArrow_White.svg';

const SpinOffLaunchPad = (props) => {
  const isMobile = Boolean(props.isMobile);
  const showCta = Boolean(props.buttonText && props.href);

  // ---------- MOBILE ----------
  if (isMobile) {
    return (
      <Box
        component="header"
        role="banner"
        sx={{
          position: 'relative',
          width: '100%',
          backgroundColor: '#FFFFFF',
          borderRadius: '48px',
          padding: '24px',
          overflow: 'visible',
          zIndex: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          boxSizing: 'border-box',
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Pally, sans-serif',
            fontWeight: 700,
            fontSize: '2.125rem',
            lineHeight: '2.125rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
          }}
        >
          {props.heading}
        </Typography>

        {props.subheading && (
          <Typography
            component="h3"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1.25rem',
              lineHeight: '1.25rem',
              letterSpacing: '-0.03em',
              textAlign: 'center',
              mt: 1,
              whiteSpace: 'pre-line',
            }}
          >
            {props.subheading}
          </Typography>
        )}

        {/* Image (centered like LaunchPadMobile) */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
          aria-hidden="true"
        >
          <Box
            sx={{
              height: '295px',
              marginTop: '20px',
              position: 'relative',
              overflow: 'visible',
              width: '295px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Image
              width={295}
              height={295}
              src={props.image}
              alt="Hippo"
              loading="eager"
              fetchPriority="high"
              sx={{
                width: '100%',
                height: 'auto',
                maxHeight: '314px',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </Box>
        </Box>

        {showCta && (
          <Box sx={{ mt: '24px' }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                window.location.href = props.href;
              }}
              sx={{
                height: '48px',
                borderRadius: '20px',
                backgroundColor: '#FF007A',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                color: '#FFFFFF',
                fontSize: '1rem',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#e6006d',
                },
              }}
            >
              {props.buttonText}
              <img
                src={DoubleArrowIcon}
                alt="Double arrow icon"
                width={20}
                height={20}
                style={{ display: 'block', marginLeft: '6px' }}
              />
            </Button>
          </Box>
        )}
      </Box>
    );
  }

  // ---------- DESKTOP (match LaunchPad styling) ----------
  return (
    <Box
      component="header"
      role="banner"
      sx={{
        position: 'relative',
        width: '1113px',
        maxWidth: '100%',
        backgroundColor: '#FFFFFF',
        borderRadius: '48px',
        p: '40px',
        overflow: 'visible',
        margin: '40px auto 0',
        minHeight: '419px',
        zIndex: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-82px',
          right: '-100px',
          width: '517px',
          height: '517px',
          transformOrigin: 'top right',
          zIndex: 1,
        }}
        aria-hidden="true"
      >
        <Image
          width={517}
          height={517}
          src={props.image}
          alt="Hippo"
          loading="eager"
          fetchPriority="high"
          sx={{
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'contain',
          }}
        />
      </Box>

      <Box
        sx={{
          zIndex: 3,
          width: '659px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Pally, sans-serif',
            fontWeight: 700,
            fontSize: { xs: '2.25rem', md: '4.5rem' },
            lineHeight: { xs: '2.5rem', md: '4.25rem' },
            letterSpacing: '-0.03em',
            whiteSpace: 'pre-line',
            mb: props.subheading ? '16px' : '32px',
          }}
        >
          {props.heading}
        </Typography>

        {props.subheading && (
          <Typography
            component="h3"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1.25rem',
              lineHeight: '1.5rem',
              letterSpacing: '-0.03em',
              mb: '32px',
              whiteSpace: 'pre-line',
            }}
          >
            {props.subheading}
          </Typography>
        )}

        {showCta && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 0,
            }}
          >
            <Box
              component="button"
              onClick={() => {
                window.location.href = props.href;
              }}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '162px',
                minHeight: '48px',
                border: 'none',
                borderRadius: '20px',
                backgroundColor: '#FF007A',
                padding: '12px 24px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                color: '#FFFFFF',
                fontSize: '1.25rem',
                lineHeight: '1.125rem',
                textTransform: 'none',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#e6006d',
                },
              }}
            >
              {props.buttonText}
              <img
                src={DoubleArrowIcon}
                alt="Double arrow icon"
                width={20}
                height={20}
                style={{ display: 'block', marginLeft: '6px' }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SpinOffLaunchPad;
